import { LabelPinType } from './label-pin-type.enum';
import { CameraModel } from '../../../engine/models/camera.model';
import { LabelThemeEnum } from './label-theme.enum';
import { LabelStateModel } from './label-state.model';
import { LabelSequentialType } from './label-sequential-type.enum';
import { ContentBlock } from 'src/app/content-blocks/models/content-block';


/**
 * 
 * 
 * Story Label Specific Properties    
 * chapterId: string; // legacy? story label specific
    expandTag = true;
    showDescription = true;
    collapseDescription = false;
    pinGlow = false;
    hideWire = false;
    hideTag = false;
    // Label States
    states: LabelStateModel[];

    flyTo: boolean;
    flyToTarget: string;
    cameraPosition: CameraModel;

    // Content
    title: string;
    description: string;


    // Content Blocks
    contentBlocks?: ContentBlock[];
 * 
 */

export class LabelModel {
    constructor(
        title: string
    ) {
        this.title = title;
    }

    // -------- NEW VALUES --------
    // Values created for Human Studio Next, which are currently not returned or expected by the server. 

    id: string; // Uses `annotationId` when available.
    chapterId: string;

    pinType: LabelPinType = LabelPinType.PlusMinus;
    sequentialType: LabelSequentialType = LabelSequentialType.Alphabetical;
    theme: LabelThemeEnum = LabelThemeEnum.StudioNext;

    expandTag = true;
    showDescription = true;
    collapseDescription = false;

    pinGlow = false;

    hideWire = false;
    hideTag = false;

    // Label States
    states: LabelStateModel[];

    flyTo: boolean;
    flyToTarget: string;
    cameraPosition: CameraModel;

    // -------- COMMON VALUES --------
    // Values returned by the server, used by Human Studio. No conversion needed.  

    // IDs
    objectId?: string; // ID of attached to node, could be in free space

    // Content
    title: string;
    description: string;

    // Content Blocks
    contentBlocks?: ContentBlock[];

    // Position (Object)
    // Only when object ID. If not populated, pin will place in the center of the object.
    barycentric?: [number, number, number]; // 0, 0, 0 = center of object
    primitiveIndex: number; // Which triangle is the pin bound to. Only when object ID.
    dir?: [number, number, number]; // Direction - the marker pointing at something.
    renderableIndex?: number; // which renderable of an object (default to 0)

    // Position (Unbound)
    pos: [number, number, number]; // Absolute position in world. 
    offset: [number, number]; // How far away is the tag from the pin

    // Visibility
    shown: boolean;
    labelShown: boolean;
    occludable: boolean;
}


export class QuizLabelModel extends LabelModel {

}
